/**
 * Created by zjs on 2017/09/05
 */
import * as types from './mutation-types'

export default {
    /**
     * 初始化全局路由配置
     */
    [types.INIT_GLOBAL_ROUTER_CONFIG] (state, config) {
        state.globalRouterConfig = config
    },
    /**
     * 更新当前路由信息
     */
    [types.UPDATE_CURR_ROUTE] (state, route) {
        state.currRoute = route
    },
    /**
     * 更新当前页面信息
     */
    [types.UPDATE_CURR_PAGE] (state, page) {
        state.currPage = page
    }
}